module.exports = __webpack_public_path__ + "static/media/ios-download.38099893.svg";